import React, { useEffect, useRef } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

const FacultyList = (props) => {

    const handleSelectionChanged = (e) => {
        props.onSelect(e);
    }

    const handleSelect = (e) => {
        props.getPerson(e.id);
        props.history.push(`/persons/person/${e.id}`);
    };

    return (
        <div className='ag-theme-balham' style={{ width: 'auto' }}>
            <DataGrid
                rows={props.data.map(x => { return { id: x.personId, ...x } })}
                onRowDoubleClick={handleSelect}
                checkboxSelection
                onRowSelectionModelChange={handleSelectionChanged}
                autoHeight={true}
                rowHeight={35}
                initialState={{
                    pagination: { paginationModel: { pageSize: 25 } },
                }}
                columns={[
                    {
                        headerName: 'Last Name',
                        field: 'displayName',
                        flex: 3,
                    },
                    {
                        headerName: 'Email',
                        field: 'email',
                        flex: 3,
                    },
                    {
                        headerName: 'Disciplines',
                        field: 'disciplines',
                        flex: 3,
                    },
                    {
                        headerName: 'Rate',
                        field: 'dailyRate',
                        flex: 3,
                        valueFormatter: (params) =>
                            params && params.value && `$${params.value}`
                    },
                    {
                        headerName: 'Type',
                        field: 'personType',
                        flex: 3,
                    }
                ]}
                sx={{
                    backgroundColor: 'white'
                }}
                getRowClassName={(params) => 'grid-row'} />
            />
        </div>
    );
};

export default FacultyList;